module.exports = __webpack_public_path__ + "img/gu.e05a076b.svg";